import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { pcompany } from '@/proto/proto';
import api from '@/api';
import { Spin } from 'antd';

const CompanySignupPage = () => {
  const { user } = useSelector((state: RootState) => state.account);
  const [loading, setLoading] = useState(false);
  const [readyCompany, setReadyCompany] = useState<pcompany.IPbCompany | null>(null);

  useEffect(() => {
    if (user && user.companyUser) {
      const companyUser = user.companyUser.filter((item: pcompany.IPbCompanyUser) => !item.statusCode || item.statusCode === 0);
      console.log(companyUser);
      if (companyUser.length > 0) {
        setLoading(true);
        api
          .get(`/company/${companyUser[0].companyId}`)
          .then(({ data }) => {
            setLoading(false);
            setReadyCompany(data);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  }, [user]);

  if (loading) {
    return <Spin />;
  }

  return (
    <div className="flex flex-col space-y-2 text-center">
      x
      {readyCompany ? (
        <div className="shadow bg-gray-100 text-center">
          <div className="font-medium p-2">승인 대기 중인 회사</div>
          <div className="bg-white p-2">{readyCompany.name}</div>
        </div>
      ) : (
        <div className="flex flex-col space-y-4">
          <div className="text-lg font-semibold text-gray-600 my-4">소속된 회사가 없습니다.</div>
          <Link to="/company/select" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            회사 선택
          </Link>
          <Link to="/company/register" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            회사 생성
          </Link>
        </div>
      )}
    </div>
  );
};

export default CompanySignupPage;
